import {
    forwardRef,
    useImperativeHandle,
    useMemo,
    useState,
} from 'react';
import {useSelector} from 'react-redux';
import { find, isFunction, isString, sortBy } from 'lodash';
import useActiveModules from '../../../../pages/centralPage/hooks/useActiveModules';
import {agylePref} from '../../../../store/reducers/preferences';
import AgyleDictionaryField from '../../../ui/selector/agyleDictionaryField';
import {
    CENTRAL_PAGE_PATH,
    MODULE_NAMES,
} from '../../../../pages/centralPage/constants';
import { getConfig } from '../../../../util/configUtil';

const CENTRAL_PAGE_OPTION_OBJ = {
  id: 'centralPage',
  name: MODULE_NAMES.CENTRAL_PAGE,
  description: 'Agyle Home',
  componentPath: CENTRAL_PAGE_PATH,
  devices: ['desktop', 'mobile', 'iPad'],
  enabled: getConfig('modules.centralPage.enabled', false),
};

const NOT_SET_OBJ = {
  id: 'notSet',
  name: "NoName",
  description: '** None **',
  componentPath: '',
  devices: ['desktop', 'mobile', 'iPad'],
  enabled: true,
};

// @TODO: Redo redirect on main application view. Currently not working as intended. @Konrad
const DefaultStartingPage = forwardRef((props, ref) => {
  const agylePreference = useSelector(agylePref);

  const [activeModules] = useActiveModules();

  const [defaultStartingPage, setDefaultStartingPage] = useState(isString(agylePreference?.defaultStartingPage) ? agylePreference?.defaultStartingPage : window.envConfig.modules.centralPage.enabled ? CENTRAL_PAGE_PATH : '');
  const selectableModules = sortBy([NOT_SET_OBJ, ...activeModules, CENTRAL_PAGE_OPTION_OBJ?.enabled ? CENTRAL_PAGE_OPTION_OBJ : null], 'description')
      .filter(mod => {
          return !isFunction(mod.componentPath) && mod.name !== MODULE_NAMES.MCT;
      });

  const currentValue = useMemo(() => find(selectableModules, {componentPath: defaultStartingPage}) || NOT_SET_OBJ, [selectableModules, activeModules, defaultStartingPage]);

  // Return default state of a component
  useImperativeHandle(ref, () => ({
    defaultState: () => {
      setDefaultStartingPage(CENTRAL_PAGE_PATH);
      return CENTRAL_PAGE_PATH;
    },
  }));

  const handleChange = (_ev, val) => {
    setDefaultStartingPage(val.componentPath);
    props.onChange('defaultStartingPage', val.componentPath);
  };

  return (
      <AgyleDictionaryField
        paperBackground
        withBackground={false}
        onChange={handleChange}
        value={currentValue}
        options={selectableModules}
        getOptionLabel={option => option.description}
        isOptionEqualToValue={(option, value) => option.componentPath === value}
      />
  );
})

export default DefaultStartingPage;